import { BaseButton, type BaseButtonProps } from './BaseButton';
import styles from './SecondaryButton.module.scss';

export function SecondaryButton(props: BaseButtonProps): React.ReactElement {
  const { children, ...restProps } = props;

  return (
    <BaseButton {...restProps} className={styles.secondaryButton}>
      {children}
    </BaseButton>
  );
}
